export default "__VITE_ASSET__07Kcb6rq__"